import { useTranslation } from 'react-i18next';

import { Divider, Typography } from 'antd';

import style from '../CheckList.module.scss';

const CheckListElement = ({ result, description, index }) => {
  const { t } = useTranslation('pokaChecklist');

  const renderResult = () => {
    switch (result?.checked) {
      case true:
        // только не для марса
        return <span>✅</span>;
      case false:
        return <span>❌</span>;
      default:
        return <span>⏳</span>;
    }
  };
  console.log('result', result);

  return (
    <div className={style['check-list__element']}>
      <Typography.Text
        className={style['check-list__description']}
        data-qa='checkListItemDesc'
      >{`${index}. ${description}`}</Typography.Text>
      {/* только не для марса */}
      <div className={style['check-list__block']}>
        {renderResult()}
        <Typography.Text className={style['check-list__block__grade']}>
          {result ? t('gradeNotNull') : t('grade')}
        </Typography.Text>
        {result?.comment && (
          <>
            <Divider orientation='left'>
              <strong>{t('comment')}</strong>
            </Divider>
            <div className={style['check-list__block__comment']}>{result?.comment}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default CheckListElement;
